/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_MASSUPLOAD_URL, COMMON_HEADER_CONFIG} from "src/config";

class OperationService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListOperation = (param) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_MASSUPLOAD_URL}/dwh/list-operations-dashboard`,
        params: param,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const operationService = new OperationService();

export default operationService;
